import { loadAcalogAPI } from "../acalogAPI.js";
import { initCourseMapToggle } from "../toggleCourseMap.js";

export function processCourseMap(module, mapContainer) {
  let semesters = mapContainer.find("h3, h4").filter(function () {
    let text = $(this).text().trim().toLowerCase();
    return text.startsWith("semest") &&
      !text.includes("minimum total credits") &&
      !text.includes("total credits");
  });

  let isAos = false;

  if (isAos) {
    processAosMode(module, semesters);
  } else {
    processDefaultMode(module, semesters);
  }

  if (typeof initCourseMapToggle === "function") {
    initCourseMapToggle();
  }
}

function fetchCourseDataAndInject() {
  // Hidden due to task request
  // $(document).on("click", ".js-programCourseMap .acalog-permalink a", function (e) {
  //   e.preventDefault();
  //
  //   const $link = $(this);
  //   const href = $link.attr("href");
  //   const $permalink = $link.closest(".acalog-permalink");
  //
  //   if (href.includes("preview_course_nopop.php")) {
  //     // Find or create the container
  //     let $container = $permalink.find(".acalog-permalink-container");
  //     if (!$container.length) {
  //       $container = $('<div class="acalog-permalink-container" style="display: none;"></div>');
  //       $permalink.append($container);
  //     }
  //
  //     // Hide all containers first
  //     $('.acalog-permalink-container').hide();
  //
  //     // Determine the API URL
  //     let apiUrl;
  //     if ($container.attr("data-acalog-ajax")) {
  //       // Use data attribute if available (already in correct format)
  //       apiUrl = `https://catalog.sunywcc.edu/widget-api${$container.attr("data-acalog-ajax")}`;
  //     } else {
  //       // Transform the href URL from query params to path format
  //       const url = new URL(href.startsWith('http') ? href : `https://catalog.sunywcc.edu${href}`);
  //       const catoid = url.searchParams.get('catoid');
  //       const coid = url.searchParams.get('coid');
  //
  //       if (catoid && coid) {
  //         apiUrl = `https://catalog.sunywcc.edu/widget-api/catalog/${catoid}/course/${coid}/`;
  //       } else {
  //         // Fallback to original href if transformation fails
  //         apiUrl = href.replace('preview_course_nopop.php', 'widget-api/preview_course_nopop.php');
  //         if (!apiUrl.startsWith('https://catalog.sunywcc.edu')) {
  //           apiUrl = `https://catalog.sunywcc.edu/widget-api${href}`;
  //         }
  //       }
  //     }
  //
  //     // Check if content already loaded
  //     if ($container.html()) {
  //       $container.show();
  //       return;
  //     }
  //
  //     // Load the content
  //     $.ajax({
  //       url: apiUrl,
  //       method: "GET",
  //       beforeSend: function () {
  //         $container.html(
  //           "Loading... Depending on your internet speed, it could take up to 30 seconds...please be patient."
  //         );
  //         $container.show();
  //       },
  //       success: function (data) {
  //         const content = `
  //           <h1 class="acalog-course-title">${data.prefix} ${data.code}&nbsp;-&nbsp;${data.name}</h1>
  //           <div class="acalog-course-body">${data.body}</div>
  //           <a href="#" class="acalog-close" aria-label="Close acalog">Close</a>
  //         `;
  //         $container.html(content);
  //       },
  //       error: function (xhr, status, error) {
  //         console.error("Error fetching course data:", error);
  //         $container.html("Error loading course data. Please try again.");
  //       },
  //     });
  //
  //   } else if (href.includes("preview_program.php")) {
  //     const cpProgramCourseMaps = '/cp-program-course-maps';
  //     const cpId    = window._cpProgramId;
  //     const cpTitle = window._cpProgramTitle;
  //
  //     const $link = $(this);
  //     const href = $link.attr('href');
  //
  //     const encodedHref  = encodeURIComponent(href);
  //     const encodedId    = encodeURIComponent(cpId);
  //     const encodedTitle = encodeURIComponent(cpTitle);
  //
  //     const goToUrl = window.location.origin + cpProgramCourseMaps + '?cp_map_url=' + encodedHref + '&cp_map_id=' + encodedId + '&cp_map_title=' + encodedTitle;
  //
  //     if (!cpId || !cpTitle) return;
  //
  //     window.location.href = goToUrl;
  //   }
  // });

  // Handle close button clicks using event delegation
  // $(document).on("click", ".acalog-close", function (e) {
  //   e.preventDefault();
  //   e.stopPropagation();
  //   $(this)
  //     .closest(".acalog-permalink-container").hide();
  // });
}

function processDefaultMode(module, semesters) {
  let coursesMobile = module.find(".js-coursesMobile");
  let coursesDesktop = module.find(".js-coursesDesktop");

  coursesMobile.html("");
  coursesDesktop.html("");

  semesters.each(function (index) {
    let semesterName = $(this).text().trim();
    let nextElement = $(this).next();
    let courses = [];
    let multipleCourses = {};

    while (nextElement.length && nextElement.prop("tagName") !== "H4") {
      if (nextElement.prop("tagName") === "TABLE") {
        let rows = nextElement.find("tr");
        let multiLinkIndex = 0;

        rows.each(function (rowIndex) {
          if (rowIndex === 0) return;

          let courseCell = $(this).find("td:first-child");
          let creditsCell = $(this).find("td:nth-child(2)");
          let credits = creditsCell.text().trim();
          let links = courseCell.find("a.acalog-permalink-link");

          if (links.length > 1) {
            // Process each link while maintaining the surrounding HTML
            let cellContent = courseCell.html();
            let $temp = $('<div>').html(cellContent);

            // Process each link in the cell
            $temp.find('a.acalog-permalink-link').each(function() {
              let $link = $(this);
              let fullUrl = $link.attr('href');
              let urlPath = fullUrl.replace("https://catalog.sunywcc.edu", "");
              let acalogUrl = `https://sunywcc.acalogadmin.com/preview${urlPath}`;

              // Replace with processed link
              $link.replaceWith(`
                <a href="${fullUrl}" class="acalog-permalink-link">
                  ${$link.html()}
                </a>
                <div class="acalog-permalink-container" data-acalog-ajax="${fullUrl}" style="display: none;"></div>
              `);
            });

            // Clean up any existing containers to avoid duplicates
            $temp.find('.acalog-permalink-container').remove();

            // Create mobile version
            let mobileHTML = `
              <div class="program__courseMap__semester__mobileCourses__course _12">
                <div class="acalog-permalink acalog-permalink-tooltip -multipleLinks">
                  ${$temp.html()}
                </div>
                <span class="credits">${credits}</span>
              </div>
            `;

            // Create desktop version
            let desktopHTML = `
              <div class="program__courseMap__semesters__desktop__semester__course _12">
                <div class="acalog-permalink acalog-permalink-tooltip -multipleLinks">
                  ${$temp.html()}
                </div>
                <span class="credits">${credits}</span>
              </div>
            `;

            multipleCourses[multiLinkIndex] = {
              mobile: mobileHTML,
              desktop: desktopHTML
            };

            courses.push({
              isMultiLink: true,
              multiLinkIndex: multiLinkIndex,
              credits: credits,
            });

            multiLinkIndex++;
          } else if (links.length === 1) {
            // Original single link processing
            let link = links.first();
            let linkContainer = courseCell.find("a + .acalog-permalink-container");

            if (link.length) {
              let fullUrl = link.attr("href");
              let urlPath = fullUrl.replace("https://catalog.sunywcc.edu", "");
              let acalogUrl = `https://sunywcc.acalogadmin.com/preview${urlPath}`;
              let ajax_course_url = linkContainer.length ? linkContainer.attr('data-acalog-ajax') : fullUrl;

              courses.push({
                title: link.text().trim(),
                url: fullUrl,
                acalogUrl: acalogUrl,
                ajax_course_url: ajax_course_url,
                credits: credits,
                isMultiLink: false
              });
            }
          } else {
            // Plain text

            let textTitle = courseCell.text().trim();

            // skip lines like “Semester Total Credits”
            if (!/Semester/i.test(textTitle)) {
              courses.push({
                title: textTitle,
                url: null,
                credits: credits,
                isMultiLink: false,
                isPlainText: true
              });
            }
          }
        });

        let totalCredits = courses.reduce((sum, c) => {
          return sum + (parseInt(c.credits) || 0);
        }, 0);

        courses.push({
          isTotal: true,
          title: "Total",
          credits: totalCredits
        });
      }
      nextElement = nextElement.next();
    }

    // Generate semester HTML (same as before)
    let semesterMobileHTML = `
  <div class="program__courseMap__semester js-courseSemester ${index === 0 ? "-active" : ""}" data-action="s-${index + 1}">
    <div class="program__courseMap__semester__title">
      ${semesterName}
      <div class="icon-mobile">
        <div class="icon-mobile-close">
          <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.5 1.63867L8 8.13867L14.5 1.63867" stroke="#55565a" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </div>
        <div class="icon-mobile-open">
          <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14 7.51855L8 1.51855L2 7.51855" stroke="#D69400" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </div>
      </div>
      <div class="icon-desktop">
        <div class="icon-mobile-close">
          <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path opacity="0.5" d="M2 13.5186L8 7.51855L2 1.51855" stroke="#55565A" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </div>
        <div class="icon-mobile-open">
          <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 13.5186L8 7.51855L2 1.51855" stroke="#D69400" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </div>
      </div>
    </div>
    <div class="program__courseMap__semester__mobileCourses">
      <div class="_title -color-baltic-blue -mb-1"><span>Course</span><span>Credits</span></div>
      <div class="program__courseMap__semester__mobileCourses__courses _w -gap-y-1">
        ${courses.map(c => {
      if (c.isTotal) {
        return `
                <div class="program__courseMap__semester__mobileCourses__course _12 course--total">
                  <div class="_value _body"><strong>${c.title}</strong></div>
                  <div class="credits"><strong>${c.credits}</strong></div>
                </div>
              `;
      } else if (c.isMultiLink) {
        return multipleCourses[c.multiLinkIndex].mobile;
      } else if (c.isPlainText) {
        return `
                <div class="program__courseMap__semester__mobileCourses__course _12">
                  <div class="_value _body">${c.title}</div>
                  <span class="credits">${c.credits}</span>
                </div>
              `;
      } else {
        return `
              <div class="program__courseMap__semester__mobileCourses__course _12 acalog-permalink acalog-permalink-tooltip">
                <a class="acalog-permalink-link" href="${c.url}"><div class="_value _body" aria-label="${c.title}">${c.title}</div></a>
                <span class="credits">${c.credits}</span>
                <div class="acalog-permalink-container" data-acalog-ajax="${c.ajax_course_url}" style="display: none;"></div>
              </div>
            `;
      }
    }).join('')}
      </div>
    </div>
  </div>
`;
    coursesMobile.append(semesterMobileHTML);

// Desktop View
    let semesterDesktopHTML = `
  <div class="program__courseMap__semesters__desktop__semester js-desktopSemesters ${index === 0 ? "-active" : ""}" data-action="s-${index + 1}">
    <div class="_title -color-baltic-blue -mb-2"><span>Course</span><span>Credits</span></div>
    <div class="program__courseMap__semesters__desktop__semester__courses _w -gap-y-1">
      ${courses.map(c => {
      if (c.isTotal) {
        return `
                <div class="program__courseMap__semesters__desktop__semester__course _12 course--total">
                  <div class="_value _body"><strong>${c.title}</strong></div>
                  <div class="credits"><strong>${c.credits}</strong></div>
                </div>
              `;
      }else if (c.isMultiLink) {
        return multipleCourses[c.multiLinkIndex].desktop;
      } else if (c.isPlainText) {
        return `
                <div class="program__courseMap__semesters__desktop__semester__course _12">
                  <div class="_value _body">${c.title}</div>
                  <span class="credits">${c.credits}</span>
                </div>
              `;
      } else {
        return `
            <div class="program__courseMap__semesters__desktop__semester__course _12 acalog-permalink acalog-permalink-tooltip">
              <a href="${c.url}" class="acalog-permalink-link"><div class="_value _body-sm" aria-label="${c.title}">${c.title}</div></a>
              <span class="credits">${c.credits}</span>
              <div class="acalog-permalink-container" data-acalog-ajax="${c.ajax_course_url}" style="display: none;"></div>
            </div>
          `;
      }
    }).join('')}
    </div>
  </div>
`;
    coursesDesktop.append(semesterDesktopHTML);
  });

  loadAcalogAPI(fetchCourseDataAndInject, true);
}

function processAosMode(module, semesters) {
  let aosCoursesContainer = module.find(".js-aosCourses");

  aosCoursesContainer.html("");

  semesters.each(function (index) {
    let semesterName = $(this).text().trim();
    let nextElement = $(this).next();
    let courses = [];

    while (nextElement.length && nextElement.prop("tagName") !== "H4") {
      if (nextElement.prop("tagName") === "TABLE") {
        let rows = nextElement.find("tr");

        rows.each(function (rowIndex) {
          if (rowIndex === 0) return;
          let courseCell = $(this).find("td:first-child");
          let link = courseCell.find("a");
          let linkContainer = courseCell.find("a + .acalog-permalink-container");

          if (link.length) {
            let fullUrl = link.attr("href");
            let urlPath = fullUrl.replace("https://catalog.sunywcc.edu", "");
            // urlPath = urlPath.replace("review_course_nopop.php", "review_course.php");
            let acalogUrl = `https://sunywcc.acalogadmin.com/preview${urlPath}`;
            let ajax_course_url = linkContainer.attr('data-acalog-ajax');

            courses.push({
              title: link.text().trim(),
              url: fullUrl,
              acalogUrl: acalogUrl,
              ajax_course_url: ajax_course_url
            });
          }
        });
      }
      nextElement = nextElement.next();
    }

    let semesterAosHTML = `
      <div class="program__aosCourses__data__section _m6">
        <h3 class="program__aosCourses__data__section__title _h3 -color-baltic-blue -mb-1">${semesterName}</h3>
        <div class="program__aosCourses__data__section__courses _w -gap-y-1">
          ${courses
      .map(
        (c) => `<div class="program__aosCourses__data__section__course _12 acalog-permalink acalog-permalink-tooltip">
                <a href="${c.url}" class="acalog-permalink-link"><div class="_value _body" aria-label="${c.title}">${c.title}</div></a>
                  <div class="acalog-permalink-container" data-acalog-ajax="${c.ajax_course_url}" style="display: none;"></div>
              </div>`
      )
      .join("")}
        </div>
      </div>
    `;
    aosCoursesContainer.append(semesterAosHTML);
  });

  loadAcalogAPI(fetchCourseDataAndInject, true);
}